import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EnvironmentService } from '../../environments/service/environment.service';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {

  constructor(private env: EnvironmentService, private router: Router) { }

  ngOnInit() {
  }

  contactPage() {
    this.router.navigate(['/contactus']);
  }
  contact(){
    this.router.navigate(['/appypartnercontactinfo']);
  }

  Signup(){
    this.router.navigate(['/Signup']);
  }

  goToApple() {
    window.open(this.env.appleUrl, '_blank');
  }

  goToAndroid() {
    window.open(this.env.androidUrl, '_blank');
  }

}
